<script>
import {Formatter} from '../Formatter'
import {emptyValuePlaceholder} from '../../utils/lang'

export default {
  name: 'Stat',
  props: {
    label: {
      type: String
    },
    // From Formatter.vue
    type: {
      type: null
    },
    value: {
      type: null
    },
    locale: {
      type: String
    },
    currency: {
      type: String
    },
    timezone: {
      type: String
    },
    inputTimezone: {
      type: String
    }
  },
  functional: true,
  render(h, {children, props, $style}) {
    const valueMarkup = props.value
      ? h(Formatter, {
          class: $style.Stat_value,
          props: props
        })
      : h('div', {
          class: $style.Stat_value
        }, children || emptyValuePlaceholder)
    return h('div', {
      class: $style.Stat
    }, [
      h('div', {
        class: $style.Stat_label
      }, [props.label]),
      valueMarkup
    ])
  }
}
</script>

<style lang="scss" module>
.Stat_label {
  padding-bottom: 2px;
  color: #212b36;
  font-weight: 500;
}
.Stat_value {
  color: #637381;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
